import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "conversionPrice",
    "sharesReceived",
    "noteCheckbox",
    "noteSection",
    "calculatedValue"
  ]

  static values = {
    investedCapitalCents: Number
  }

  connect() {
    this._userEditedShares = false
  }

  calculateShares() {
    const priceDollars = parseFloat(this.conversionPriceTarget.value.replace(/[,$_]/g, "")) || 0
    if (priceDollars <= 0) {
      if (!this._userEditedShares) {
        this.sharesReceivedTarget.value = ""
      }
      this.updateCalculatedValue()
      return
    }

    const investedDollars = this.investedCapitalCentsValue / 100.0
    const shares = Math.floor(investedDollars / priceDollars)

    if (!this._userEditedShares) {
      this.sharesReceivedTarget.value = shares
    }

    this.updateCalculatedValue()
  }

  sharesEdited() {
    this._userEditedShares = true
    this.updateCalculatedValue()
  }

  updateCalculatedValue() {
    if (!this.hasCalculatedValueTarget) return

    const priceDollars = parseFloat(this.conversionPriceTarget.value.replace(/[,$_]/g, "")) || 0
    const shares = parseFloat(this.sharesReceivedTarget.value) || 0
    const value = shares * priceDollars

    this.calculatedValueTarget.textContent = value > 0
      ? `Equity value: $${value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      : ""
  }

  toggleNoteSection() {
    if (!this.hasNoteSectionTarget) return

    if (this.noteCheckboxTarget.checked) {
      this.noteSectionTarget.classList.remove("hidden")
    } else {
      this.noteSectionTarget.classList.add("hidden")
    }
  }
}
